import DynamicComponent from ".."
import FormSection from "components/FormSection"
import OfficeTeamGrid from "components/OfficeTeamGrid"
import { useEffect, useState } from "react"
import compareByLastName from "utilities/compareByLastName"

export default function NationalSalesPage({ story }) {
  const [salesTeam, setSalesTeam] = useState(null)
  const [supportTeam, setSupportTeam] = useState(null)

  useEffect(() => {
    // Sort items randomly, except for leadership (which shows first)
    // Always force Matt Chamberlin to be first (above other leaders)
    const sortItems = (items) => {
      if (!items) return

      return items.sort((a, b) => {
        if (a.content.sticky) return -1 // a is sticky, always goes first
        if (b.content.sticky) return 1 // b is sticky, always goes first

        const aHasLeadership = a.content?.department.includes("Leadership")
        const bHasLeadership = b.content?.department.includes("Leadership")

        if (aHasLeadership && !bHasLeadership) {
          return -1 // a goes before b
        } else if (!aHasLeadership && bHasLeadership) {
          return 1 // b goes before a
        } else if (aHasLeadership && bHasLeadership) {
          // Sort leadership alphabetically
          return compareByLastName(a.content.name, b.content.name)
        } else {
          return Math.random() - 0.5 // Random order for the rest
        }
      })
    }

    setSalesTeam(sortItems(story?.salesTeam?.items))
    setSupportTeam(sortItems(story?.supportTeam?.items))
  }, [story?.supportTeam?.items, story?.salesTeam?.items])

  return (
    <main className="page-content">
      {story?.page?.content?.blocks.map((blok) => (
        <DynamicComponent blok={blok} key={blok._uid} />
      ))}

      <OfficeTeamGrid
        teamMembers={salesTeam}
        secondaryTeamMembers={supportTeam}
        heading="The 2060 Digital National Team"
        eyebrow="Meet Us"
      />

      <FormSection eyebrow="Let's Connect" heading="Contact Our" heading2="National Sales Team" />
    </main>
  )
}
